module.exports = __webpack_public_path__ + "img/T2B_xh_2.e0ebeefb.png";